import { isPlatformBrowser } from '@angular/common';
import {
  EventEmitter,
  Inject,
  Injectable,
  PLATFORM_ID,
} from '@angular/core';

import {
  BehaviorSubject,
  Subject,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  searchParameters = new BehaviorSubject<any>(null);
  selectedItemDetailsParameters = new BehaviorSubject<any>(null);
  bookingDetailsParameters = new BehaviorSubject<any>(null);
  currenctCurrencyParam = new BehaviorSubject<any>(null);
  previousCurrencyParam = new BehaviorSubject<any>(null);
  selectedLanguageParam = new BehaviorSubject<any>(null);
  bookingSuccessParam = new BehaviorSubject<any>(null);
  GeoLocationParam = new BehaviorSubject<any>(null);
  preBookingDetailsParameters = new BehaviorSubject<any>(null);
  preTourGradesParams = new BehaviorSubject<any>(null);
  roomDetails = new BehaviorSubject<any>(null);
  voucherDetails = new BehaviorSubject<any>(null);
  tempReferenceID = new BehaviorSubject<any>(null);
  euroCarPlans = new BehaviorSubject<any>(null);
  hotelCancelDtls = new BehaviorSubject<any>(null);
  papalBookingItemDetails = new BehaviorSubject<any>(null);
  billingDetails = new BehaviorSubject<any>(null);
  loginUserId = new BehaviorSubject<any>(null);
  tempcurencySet = new Subject<any>();
  setCurrencyInPages$ = new Subject<any>();
  paypalFailureDetails = new BehaviorSubject<any>(null);
  agebanddetails = new BehaviorSubject<any>(null);
  travellerDtls = new BehaviorSubject<any>(null);
  hotelDtlsReq = new BehaviorSubject<any>(null);
  hotelBkReq = new BehaviorSubject<any>(null);
  couponObj = new BehaviorSubject<any>(null);
  minmax = new BehaviorSubject<any>(null);
  minmax$ = this.minmax.asObservable();

  closeMenuFromOtherService$ = new Subject<any>();
  removeSelectedFlight$ = new Subject<any>();


  searchRequestParam$ = this.searchParameters.asObservable();
  selectedItemDetailsParam$ = this.selectedItemDetailsParameters.asObservable();
  bookingDetailsParam$ = this.bookingDetailsParameters.asObservable();
  currenctCurrencyParam$ = this.currenctCurrencyParam.asObservable();

  userDetailsParam = new BehaviorSubject<any>(null);
  userLoggedInParam = new BehaviorSubject<any>(null);
  userMenusListParam = new BehaviorSubject<any>(null);
  orgCodeParam=new BehaviorSubject<any>(null);
  // userDetailsParam$ = this.userDetailsParam.asObservable();





  previousCurrencyParam$ = this.previousCurrencyParam.asObservable();
  selectedLanguageParam$ = this.selectedLanguageParam.asObservable();
  bookingSuccessParam$ = this.bookingSuccessParam.asObservable();
  GeoLocationParam$ = this.GeoLocationParam.asObservable();
  preBookingDetailsParams$ = this.preBookingDetailsParameters.asObservable();
  preTourGrades$ = this.preTourGradesParams.asObservable();
  roomDetails$ = this.roomDetails.asObservable();
  voucherDetails$ = this.voucherDetails.asObservable();
  tempReferenceID$ = this.tempReferenceID.asObservable();
  flightDetails = new BehaviorSubject<any>(null);
  flightDetails$ = this.flightDetails.asObservable();
  loginSuccess = new BehaviorSubject<any>(null);
  loginSuccess$ = this.loginSuccess.asObservable();
  tabchangedtls = new BehaviorSubject<any>(null);
  tabchangedtls$ = this.tabchangedtls.asObservable();
  sellStatus = new BehaviorSubject<any>(null);
  sellStatus$ = this.sellStatus.asObservable();
  segmentCount = new BehaviorSubject<any>(null);
  segmentCount$ = this.segmentCount.asObservable();
  forgotchangedtls = new BehaviorSubject<any>(null);
  forgotchangedtls$ = this.forgotchangedtls.asObservable();
  euroCarPlans$ = this.euroCarPlans.asObservable();
  airports = new BehaviorSubject<any>(null);
  airportobj$ = this.airports.asObservable();
  clearSelectedFlight = new EventEmitter();
  hotelCancelDtls$ = this.hotelCancelDtls.asObservable();
  papalBookingItemDetails$ = this.papalBookingItemDetails.asObservable();
  billingDetails$ = this.billingDetails.asObservable();
  loginUserId$ = this.loginUserId.asObservable();
  infantDetails = new BehaviorSubject<any>(null);
  infantDetails$ = this.infantDetails.asObservable();
  logOutUserId = new BehaviorSubject<any>(null);
  PaymentSearchParams$ = new BehaviorSubject<any>(null);

  PaymentSearchParams = this.PaymentSearchParams$.asObservable();
  clearSelectedFlightAfterTimeout = new EventEmitter();
  errorObjectInfo$ = new BehaviorSubject<any>(null);
  errorObjectInfoParas = this.errorObjectInfo$.asObservable();




  tempcurencySet$ = this.tempcurencySet.asObservable();
  paymentCurrency = new BehaviorSubject<any>(null);
  paymentCurrency$ = this.paymentCurrency.asObservable();
  city = new BehaviorSubject<any>(null);

  signupRedirectUrl = new BehaviorSubject<any>(null);
  signupRedirectUrl$ = this.signupRedirectUrl.asObservable();
  paypalFailureDetails$ = this.paypalFailureDetails.asObservable();

  agebanddetails$ = this.agebanddetails.asObservable();
  travellerDtls$ = this.travellerDtls.asObservable();

  flightExtras = new BehaviorSubject<any>(null);
  flightExtras$ = this.flightExtras.asObservable();

  amounts = new BehaviorSubject<any>(null);
  amounts$ = this.amounts.asObservable();

  paymentCards = new BehaviorSubject<any>(null);
  paymentCards$ = this.paymentCards.asObservable();
  selectDepartureFlight = new EventEmitter();

  assignedSeats = new BehaviorSubject<any>(null);
  assignedSeats$ = this.assignedSeats.asObservable();

  airlinesList = new BehaviorSubject<any>(null);
  airlinesList$ = this.airlinesList.asObservable();

  airportsList = new BehaviorSubject<any>(null);
  airportsList$ = this.airportsList.asObservable();
  hotelDtlsReq$ = this.hotelDtlsReq.asObservable();
  hotelBkReq$ = this.hotelBkReq.asObservable();

  postAnclConfirmationData = new BehaviorSubject<any>(null);
  postAnclConfirmationData$ = this.postAnclConfirmationData.asObservable();

  sessionObject = new Subject();
  sessionObject$ = this.sessionObject.asObservable();

  isAncillarySelected = new Subject();
  isAncillarySelected$ = this.isAncillarySelected.asObservable();
  isCurrencyLoading = new EventEmitter(false);

  navigateToSigninFromBookingPage = new BehaviorSubject<any>(null);
  navigateToSignupFromBookingPage = new BehaviorSubject<any>(null);



  navigateToSigninFromSignupPage = new BehaviorSubject<any>(false)
  navigateToSignupFromSigningPage = new BehaviorSubject<any>(false)
  navigateToAgentSignupFromSigningPage=new BehaviorSubject<any>(false);

  clientUserIp$ = new BehaviorSubject<any>(null);
  rememberMeUserDetails$ = new BehaviorSubject<any>(undefined);
  loginDataAlreadyAvailable$ = new BehaviorSubject<any>(undefined);
  ipAddressUrl$ = new BehaviorSubject<string>('');
  cookieChoice: boolean;
  requestIDList$ = new BehaviorSubject<Array<{ page: string, requestId: string, fetched: boolean }>>([]);
  token$ = new BehaviorSubject<any>(null);
  couponObjectForMultiCity$ = new BehaviorSubject<any>(undefined);

  PassengerDetailsParameters = new BehaviorSubject<any>(undefined);



  carSearchParams$ = new BehaviorSubject<any>(undefined);
  carDetailsParams$ = new BehaviorSubject<any>(undefined);
  carPaymentDetailsParams$ = new BehaviorSubject<any>(undefined);
  carBookingSuccessParams$ = new BehaviorSubject<any>(undefined);




  ActivitySearchParams$ = new BehaviorSubject<any>(undefined);
  ActivityDetailsParams$ = new BehaviorSubject<any>(undefined);
  ActivityPaymentDetailsParams$ = new BehaviorSubject<any>(undefined);
  ActivityBookingSuccessParams$ = new BehaviorSubject<any>(undefined);
  ActivityTravellerInfoSuccessParams$ = new BehaviorSubject<any>(undefined);
  requestIDListSession$ = new BehaviorSubject<any>(undefined);
  storeBrowserInformationSuccess$ = new BehaviorSubject<any>(undefined);


  postAncilaryPaypalDetailsParams$ = new BehaviorSubject<any>(undefined);

  mobileDeviceParams$ = new BehaviorSubject<boolean>(true);

  flightResultsAreProcessing = new Subject();
  closeModalWindowAfterLogin$ = new BehaviorSubject<any>(undefined);

  filterAirlinesList = new BehaviorSubject<any>(undefined);
  filterAirportsList = new BehaviorSubject<any>(undefined);
  filterCancellationTypes = new BehaviorSubject<any>(undefined);


  closeReferenceFromOtherFiles = new Subject();


  constructor(@Inject(PLATFORM_ID) private platformId) {
    let params;

    // this.userDetailsParam = new BehaviorSubject<any>(undefined);
    // this.userLoggedInParam = new BehaviorSubject<any>(undefined);

    this.closeModalWindowAfterLogin$ = new BehaviorSubject<any>(undefined);
    this.clientUserIp$ = new BehaviorSubject<any>(null);
    
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (localStorage.getItem('errorObjectMessageInfo') != undefined) {
        params = (localStorage.getItem('errorObjectMessageInfo'));
        if (params != null) {
          this.errorObjectInfo$.next(params);
        }
      }


      if (localStorage.getItem('mobileDeviceParams') != undefined) {
        params = (localStorage.getItem('mobileDeviceParams'));
        if (params != null) {
          this.mobileDeviceParams$.next(params);
        }
      }

      if (localStorage.getItem('UserObj') != undefined) {
        params = JSON.parse(localStorage.getItem('UserObj'));
        if (params != null) {
          this.userDetailsParam.next((params));
        }
      }

      if (localStorage.getItem('menuList') != undefined) {
        params = JSON.parse(localStorage.getItem('menuList'));
        if (params != null) {
          this.userMenusListParam.next((params));
        }
      }

      if (localStorage.getItem('orgCode') != undefined) {
        params = localStorage.getItem('orgCode');
        if (params != null) {
          this.orgCodeParam.next((params));
        }
      }



      if (localStorage.getItem('LoggedIn') != undefined) {
        params = (localStorage.getItem('LoggedIn'));
        if (params != null) {
          this.userLoggedInParam.next(params);
        } else {
          this.userLoggedInParam.next(false);
        }
      }

    }

    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (localStorage.getItem('minMaxValues') != undefined) {
        params = JSON.parse(localStorage.getItem('minMaxValues'));
        if (params != null) {
          this.minmax.next(params);
        }
      }
    }


    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (localStorage.getItem('PostAncilaryPaypalDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('PostAncilaryPaypalDetails'));
        if (params != null) {
          this.postAncilaryPaypalDetailsParams$.next(params);
        }
      }
    }



    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (localStorage.getItem('CouponObjectForMultiCity') != undefined) {
        params = JSON.parse(localStorage.getItem('CouponObjectForMultiCity'));
        if (params != null) {
          this.couponObjectForMultiCity$.next(params);
        }
      }
    }

    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (localStorage.getItem('EuroCarPlans') != undefined) {
        params = JSON.parse(localStorage.getItem('EuroCarPlans'));
        if (params != null) {
          this.euroCarPlans.next(params);
        }
      }


      if (localStorage.getItem('BrowserInformation') != undefined) {
        params = JSON.parse(localStorage.getItem('BrowserInformation'));
        if (params) {
          this.storeBrowserInformationSuccess$.next(params);
        }
      }


      if (localStorage.getItem('clientip') != undefined) {
        params = localStorage.getItem('clientip');
        if (params) {
          this.clientUserIp$.next(params);
        }
      }


      if (localStorage.getItem('searchParams') != undefined) {
        params = JSON.parse(localStorage.getItem('searchParams'));
        if (params != null) {
          this.searchParameters.next(params);
        }
      }
      if (localStorage.getItem('selectedItemDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('selectedItemDetails'));

        if (params != null) {
          this.selectedItemDetailsParameters.next(params);
        }
      }

      if (localStorage.getItem('bookingDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('bookingDetails'));
        if (params != null) {
          this.bookingDetailsParameters.next(params);
        }
      }


      if (localStorage.getItem('currentcurrency') != undefined) {
        params = localStorage.getItem('currentcurrency');
        if (params != null) {
          this.currenctCurrencyParam.next(params);
        }
      }
      if (localStorage.getItem('previouscurrency') != undefined) {
        params = localStorage.getItem('previouscurrency');
        if (params != null) {
          this.previousCurrencyParam.next(params);
        }
      }

      if (localStorage.getItem('lang') != undefined) {
        params = localStorage.getItem('lang');
        if (params != null) {
          this.selectedLanguageParam.next(params);
        }
      }

      if (localStorage.getItem('bookingsuccess') != undefined) {
        params = JSON.parse(localStorage.getItem('bookingsuccess'));
        if (params != null) {
          this.bookingSuccessParam.next(params);
        }
      }

      if (localStorage.getItem('geolocation') != undefined) {
        params = JSON.parse(localStorage.getItem('geolocation'));
        if (params != null) {
          this.GeoLocationParam.next(params);
        }
      }

      if (localStorage.getItem('setRoomDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('setRoomDetails'));
        if (params != null) {
          this.roomDetails.next(params);
        }
      }
      if (localStorage.getItem('prebookingDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('prebookingDetails'));
        if (params != null) {
          this.preBookingDetailsParameters.next(params);
        }
      }
      if (localStorage.getItem('pretourgrade') != undefined) {
        params = JSON.parse(localStorage.getItem('pretourgrade'));
        if (params != null) {
          this.preTourGradesParams.next(params);
        }
      }

      if (localStorage.getItem('setVoucherDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('setVoucherDetails'));
        if (params != null) {
          this.voucherDetails.next(params);
        }
      }

      if (localStorage.getItem('sellStatus') != undefined) {
        params = JSON.parse(localStorage.getItem('sellStatus'));
        if (params != null) {
          this.sellStatus.next(params);
        }
      }

      if (localStorage.getItem('segmentCount') != undefined) {
        params = JSON.parse(localStorage.getItem('segmentCount'));
        if (params != null) {
          this.segmentCount.next(params);
        }
      }

      if (localStorage.getItem('tempRefId') != undefined) {
        params = localStorage.getItem('tempRefId');
        if (params != null) {
          this.tempReferenceID.next(params);
        }
      }

      if (localStorage.getItem('airportobj') != undefined) {
        params = JSON.parse(localStorage.getItem('airportobj'));
        if (params != null) {
          this.airports.next(params);
        }
      }

      if (localStorage.getItem('hotelCancelItems') != undefined) {
        params = JSON.parse(localStorage.getItem('hotelCancelItems'));
        if (params != null) {
          this.hotelCancelDtls.next(params);
        }
      }

      if (localStorage.getItem('papalBookingItemDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('papalBookingItemDetails'));
        if (params != null) {
          this.papalBookingItemDetails.next(params);
        }
      }

      if (localStorage.getItem('billingAddress') != undefined) {
        params = JSON.parse(localStorage.getItem('billingAddress'));
        if (params != null) {
          this.billingDetails.next(params);
        }
      }

      if (localStorage.getItem('UserID') != undefined) {
        params = localStorage.getItem('UserID');
        if (params) {
          this.loginUserId.next(params);
        }
      }

      if (localStorage.getItem('infObj') != undefined) {
        params = JSON.parse(localStorage.getItem('infObj'));
        if (params) {
          this.infantDetails.next(params);
        }
      }

      if (localStorage.getItem('PaymentSearchParams') != undefined) {
        params = JSON.parse(localStorage.getItem('PaymentSearchParams'));
        console.log(params);
        if (params) {
          this.PaymentSearchParams$.next(params);
        }
      }

      // localStorage.setItem('PaymentSearchParams', JSON.stringify(infObj));
      // this.PaymentSearchParams$.next(infObj);

      if (localStorage.getItem('paymentCurrency') != undefined) {
        params = localStorage.getItem('paymentCurrency');
        if (params) {
          this.paymentCurrency.next(params);
        }
      }

      if (localStorage.getItem('redirectUrl') != undefined) {
        params = localStorage.getItem('redirectUrl');
        if (params) {
          this.signupRedirectUrl.next(params);
        }
      }
      if (localStorage.getItem('paypalFailureDetails') != undefined) {
        params = JSON.parse(localStorage.getItem('paypalFailureDetails'));
        if (params) {
          this.paypalFailureDetails.next(params);
        }
      }

      if (localStorage.getItem('agebands') != undefined) {
        params = JSON.parse(localStorage.getItem('agebands'));
        if (params != null) {
          this.agebanddetails.next(params);
        }
      }
      if (localStorage.getItem('travellerObj') != undefined) {
        params = JSON.parse(localStorage.getItem('travellerObj'));
        if (params != null) {
          this.travellerDtls.next(params);
        }
      }

      if (localStorage.getItem('extras') != undefined) {
        params = JSON.parse(localStorage.getItem('extras'));
        if (params != null) {
          this.flightExtras.next(params);
        }
      }

      if (localStorage.getItem('amounts') != undefined) {
        params = JSON.parse(localStorage.getItem('amounts'));
        if (params != null) {
          this.amounts.next(params);
        }
      }

      if (localStorage.getItem('paymentCards') != undefined) {
        params = JSON.parse(localStorage.getItem('paymentCards'));
        if (params != null) {
          this.paymentCards.next(params);
        }
      }

      if (localStorage.getItem('assignedseats') != undefined) {
        params = JSON.parse(localStorage.getItem('assignedseats'));
        if (params != null) {
          this.assignedSeats.next(params);
        }
      }

      if (localStorage.getItem('airlines') != undefined) {
        params = JSON.parse(localStorage.getItem('airlines'));
        if (params != null) {
          this.airlinesList.next(params);
        }
      }

      if (localStorage.getItem('airports') != undefined) {
        params = JSON.parse(localStorage.getItem('airports'));
        if (params != null) {
          this.airportsList.next(params);
        }
      }

      if (localStorage.getItem('htldtls_req') != undefined) {
        params = localStorage.getItem('htldtls_req');
        if (params != null) {
          this.hotelDtlsReq.next(params);
        }
      }
      if (localStorage.getItem('htlbk_req') != undefined) {
        params = localStorage.getItem('htlbk_req');
        if (params != null) {
          this.hotelBkReq.next(params);
        }
      }

      if (localStorage.getItem('post_ancl_success') != undefined) {
        params = JSON.parse(localStorage.getItem('post_ancl_success'));
        if (params != null) {
          this.postAnclConfirmationData.next(params);
        }
      }

      if (localStorage.getItem('sessionObj') != undefined) {
        params = JSON.parse(localStorage.getItem('sessionObj'));
        if (params != null) {
          this.sessionObject.next(params);
        }
      }

      if (localStorage.getItem('isAncillaryDone') != undefined) {
        params = JSON.parse(localStorage.getItem('isAncillaryDone'));
        if (params != null) {
          this.isAncillarySelected.next(params);
        }
      }

      if (localStorage.getItem('LoggegIn') != undefined) {
        params = JSON.parse(localStorage.getItem('LoggegIn'));
        if (params) {
          this.rememberMeUserDetails$.next(params);
        }
      }

      if (localStorage.getItem('couponObj') != undefined) {
        params = JSON.parse(localStorage.getItem('couponObj'));
        if (params) {
          this.couponObj.next(params);
        }
      }

      if (localStorage.getItem('requestIDList') != undefined) {
        params = JSON.parse(localStorage.getItem('requestIDList'));
        if (params) {
          this.requestIDList$.next(params);
          this.requestIDListSession$.next(params);
        } else {
          this.requestIDList$.next(undefined);
          this.requestIDListSession$.next([]);

        }
      } else {
        this.requestIDListSession$.next([]);
      }

      // if (sessionStorage.getItem('requestIDList') != undefined) {
      //   params = JSON.parse(sessionStorage.getItem('requestIDList'));
      //   console.log(params);
      //   if (params) {
      //     this.requestIDListSession$.next(params);
      //   } else {
      //     this.requestIDListSession$.next([]);
      //   }
      // } else {
      //   this.requestIDListSession$.next([]);
      // }

      if (localStorage.getItem('token') != undefined) {
        params = JSON.stringify(localStorage.getItem('token'));
        if (params) {
          this.token$.next(params);
        }
      }


      if (localStorage.getItem('carDetailsParams') != undefined) {
        params = localStorage.getItem('carDetailsParams');
        if (params) {
          this.carDetailsParams$.next(params);
          localStorage.removeItem('carDetailsParams');
        }
      }



      if (localStorage.getItem('ActivityDetailsParams') != undefined) {
        params = localStorage.getItem('ActivityDetailsParams');
        if (params) {
          this.ActivityDetailsParams$.next(params);
          localStorage.removeItem('ActivityDetailsParams');
        }
      }



      if (localStorage.getItem('ActivitySearchParams') != undefined) {
        params = localStorage.getItem('ActivitySearchParams');
        if (params) {
          this.ActivitySearchParams$.next(JSON.parse(params));
          localStorage.removeItem('ActivitySearchParams');
        }
      }


      if (localStorage.getItem('PassengerDetailsArray') != undefined) {
        params = localStorage.getItem('PassengerDetailsArray');
        if (params) {
          this.PassengerDetailsParameters.next(JSON.parse(params));
        }
      }

      // if (details != null) {
      //   localStorage.setItem('PassengerDetailsArray', JSON.stringify(details));
      //   this.PassengerDetailsParameters.next(details);
      // }

    }
  }

  setCancellationTypesList(params) {
    this.filterCancellationTypes.next(params);
  }
  

  setFilterAirlinesList(params) {
    this.filterAirlinesList.next(params);
  }

  setFilterAirportsList(params) {
    this.filterAirportsList.next(params);
  }

  setErrorObjectInfo(errorObject){
    if (errorObject)
      if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
        if (errorObject) {
          localStorage.setItem('errorObjectMessageInfo', JSON.stringify(errorObject));
          this.errorObjectInfo$.next((errorObject));
        }
      }
  }

  getErrorObjectInfo(){
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      let params = localStorage.getItem('errorObjectMessageInfo');
      // this.mobileDeviceParams$.next(JSON.parse(params));
    }
  }

  flightResultsAreProcessingParams(value) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      this.flightResultsAreProcessing.next(value);
    }
  }




  setIsMobileOrNOtFlag(params) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      // if (params != null && params != undefined && params != "") {

      localStorage.setItem('mobileDeviceParams', params);
      this.mobileDeviceParams$.next(params);
      // }
    }
  }




  removeSeat() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {

      localStorage.removeItem('assignedseats');
      this.assignedSeats.next(null);
    }
  }


  removePassengerDetailsArray() {

    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {

      localStorage.removeItem('PassengerDetailsArray');
      this.PassengerDetailsParameters.next(null);
    }

  }


  setPostAncilaryPaypalDetails(params) {
    if (params)
      if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
        if (params) {
          localStorage.setItem('PostAncilaryPaypalDetails', JSON.stringify(params));
          this.postAncilaryPaypalDetailsParams$.next(JSON.stringify(params));
        }
      }
  }



  setMulticityCouponObject(params) {
    if (params)
      if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
        if (params) {
          localStorage.setItem('CouponObjectForMultiCity', JSON.stringify(params));
          this.couponObjectForMultiCity$.next(JSON.stringify(params));
        }
      }
  }


  setBrowserInformationInStorage(params) {
    if (params)
      if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
        if (params) {
          localStorage.setItem('BrowserInformation', JSON.stringify(params));
          this.storeBrowserInformationSuccess$.next(JSON.stringify(params));
        }
      }
  }

  setActivityTravellerInfoSuccessParams(ActivityTravellerInfoSuccess) {
    if (ActivityTravellerInfoSuccess)
      this.ActivityTravellerInfoSuccessParams$.next(ActivityTravellerInfoSuccess);
    else
      this.ActivityTravellerInfoSuccessParams$.next(null);
  }


  setActivityPaymentSuccessParams(ActivityBookingSuccess) {
    if (ActivityBookingSuccess)
      this.ActivityBookingSuccessParams$.next(ActivityBookingSuccess);
    else
      this.ActivityBookingSuccessParams$.next(null);
  }


  setActivityPaymentDetailsParams(ActivityPaymentObj) {
    if (ActivityPaymentObj)
      this.ActivityPaymentDetailsParams$.next(ActivityPaymentObj);
    else
      this.ActivityPaymentDetailsParams$.next(null);

  }


  removeActivityDetailsParam() {
    localStorage.removeItem('ActivityDetailsParams');

  }


  setActivityDetailsParams(ActivitySearchObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (ActivitySearchObj) {
        localStorage.setItem('ActivityDetailsParams', JSON.stringify(ActivitySearchObj));
        this.ActivityDetailsParams$.next(JSON.stringify(ActivitySearchObj));
      }
    }
  }



  setActivitySearchParams(ActivitySearchObj) {
    if (ActivitySearchObj) {
      localStorage.setItem('ActivitySearchParams', JSON.stringify(ActivitySearchObj));
      this.ActivitySearchParams$.next(ActivitySearchObj);
    }
    else
      this.ActivitySearchParams$.next(null);
  }




  setCarPaymentSuccessParams(carBookingSuccess) {
    if (carBookingSuccess)
      this.carBookingSuccessParams$.next(carBookingSuccess);
    else
      this.carBookingSuccessParams$.next(null);
  }


  setcarPaymentDetailsParams(carPaymentObj) {
    if (carPaymentObj)
      this.carPaymentDetailsParams$.next(carPaymentObj);
    else
      this.carPaymentDetailsParams$.next(null);

  }



  setCarDetailsParams(carSearchObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (carSearchObj) {
        localStorage.setItem('carDetailsParams', JSON.stringify(carSearchObj));
      }
    }
  }



  setCarSearchParams(carSearchObj) {
    if (carSearchObj)
      this.carSearchParams$.next(carSearchObj);
    else
      this.carSearchParams$.next(null);
  }


  setClientIpIn(userIp) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (userIp) {
        localStorage.setItem('clientip', userIp);
        this.clientUserIp$.next(userIp);
      }
    }
  }

  navigateToSigninFromSignup(value) {
    this.navigateToSigninFromSignupPage.next(value);
  }


  navigateToSignupFromSigning(value) {
    this.navigateToSignupFromSigningPage.next(value);
  }


  navigateToAgentSignupFromSigning(value) {
    this.navigateToAgentSignupFromSigningPage.next(value);
  }



  navigateToSgninFromBooking(value) {
    this.navigateToSigninFromBookingPage.next(value);
  }


  navigateToSgnupFromBooking(value) {
    this.navigateToSignupFromBookingPage.next(value);
  }



  removeBookingSuccessParams() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('bookingsuccess');
    }
  }


  setUserIdAfterLogin(userId) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (userId) {
        localStorage.setItem('UserID', userId);
        this.loginUserId.next(userId);
      } else {
        this.loginUserId.next(null);
      }
    }
  }

  removeUserObject() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('UserObj');
      this.userDetailsParam.next(null);
      this.userMenusListParam.next(null);
      this.orgCodeParam.next(null);
    }
  }
  removeLoggedObject() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('LoggegIn');
    }
  }

  /**
   * This function is used to remove userID from localstorage
   * after logout done successfully.
   */
  removeUserIdAfterLogout() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('UserID');
    }
    this.logOutUserId.next(true);
  }

  setSignupRedirectUrl(url) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (url) {
        localStorage.setItem('redirectUrl', url);
        this.signupRedirectUrl.next(url);
      }
    }
  }

  removeRedirectUrlAfterSignUp() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('redirectUrl');
      this.signupRedirectUrl.next(null);
    }
  }

  setPaypalBookingDetails<T>(params) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (params != null) {
        localStorage.setItem('papalBookingItemDetails', JSON.stringify(params));
        this.papalBookingItemDetails.next(params);
      }
    }
  }

  setGeoLocationParams<T>(params) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (params != null) {
        localStorage.setItem('geolocation', JSON.stringify(params));
        this.GeoLocationParam.next(params);
      }
    }
  }

  setSearchParams<T>(params) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (params != null) {
        localStorage.setItem('searchParams', JSON.stringify(params));
        this.searchParameters.next(params);
      }
    }
  }

  setSelectedItemDetails<T>(details) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (details != null) {
        console.log(JSON.stringify(details));
        localStorage.setItem('selectedItemDetails', JSON.stringify(details));
        localStorage.setItem('selectedItemDetailsMultiCity', JSON.stringify(details.couponObj));
        console.log(JSON.stringify(localStorage.getItem('selectedItemDetails')));

        this.selectedItemDetailsParameters.next(details);
      }
    }
  }

  setBookingDetails<T>(details) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (details != null) {
        localStorage.setItem('bookingDetails', JSON.stringify(details));
        this.bookingDetailsParameters.next(details);
      }
    }
  }

  setPassengerDetails(details) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (details != null) {
        localStorage.setItem('PassengerDetailsArray', JSON.stringify(details));
        this.PassengerDetailsParameters.next(details);
      }
    }
  }


  setRememberMeUserDetails(userObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (userObj) {
        localStorage.setItem('LoggegIn', userObj);
        // this.infantDetails.next(userObj);
      }
    }
  }


  setLoginUserDetails(userObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (userObj) {
        localStorage.setItem('UserObj', JSON.stringify(userObj));
        this.userDetailsParam.next(userObj)
      }
    }
  }

  setMenuListDetails(userObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (userObj) {
        localStorage.setItem('menuList', JSON.stringify(userObj));
        this.userMenusListParam.next(userObj)
      }
    }
  }

  setOrgCodeDetails(userObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (userObj) {
        localStorage.setItem('orgCode', userObj);
        this.orgCodeParam.next(userObj)
      }
    }
  }

  setCurrentCurrency(currCurrency) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (currCurrency) {
        localStorage.setItem('currentcurrency', currCurrency);
        this.currenctCurrencyParam.next(currCurrency);
      }
    }

  }

  setPreviousCurrency<T>(prevCurrency) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (prevCurrency != null) {
        localStorage.setItem('previouscurrency', prevCurrency);
        this.previousCurrencyParam.next(prevCurrency);
      }
    }
  }

  setCurrentLanguagge<T>(language) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (language != null) {
        localStorage.setItem('lang', language);
        this.selectedLanguageParam.next(language);
      }
    }
  }

  setBookingSuccess<T>(bookinginfo) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (bookinginfo != null) {
        localStorage.setItem('bookingsuccess', JSON.stringify(bookinginfo));
        this.bookingSuccessParam.next(bookinginfo);
      }
    }
  }

  setFlightDetails(flightObj) {
    this.flightDetails.next(flightObj);
  }
  setPreBookingDetails<T>(details) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (details != null) {
        localStorage.setItem('prebookingDetails', JSON.stringify(details));
        this.preBookingDetailsParameters.next(details);
      }
    }
  }

  setTourgrade<T>(details) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (details != null) {
        localStorage.setItem('pretourgrade', JSON.stringify(details));
        this.preTourGradesParams.next(details);
      }
    }
  }
  removeItemsAfterPaymentSuccess() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('bookingDetails');
      localStorage.removeItem('selectedItemDetails');
    }
  }
  removePaymentDataAndSelectedItem() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('bookingsuccess');
    }
  }

  setRoomsDetails<T>(details) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (details != null) {
        localStorage.setItem('setRoomDetails', JSON.stringify(details));
        this.roomDetails.next(details);
      }
    }
  }

  removeRoomDtls() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('setRoomDetails');
      this.roomDetails.next(null);
    }
  }

  removeHotelDtls() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('setRoomDetails');
      localStorage.removeItem('paypalFailureDetails');
      localStorage.removeItem('bookingDetails');
      localStorage.removeItem('hotelCancelItems');
      localStorage.removeItem('papalBookingItemDetails');
      localStorage.removeItem('couponObj');
    }
  }

  setVoucherDtls<T>(details) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (details != null) {
        localStorage.setItem('setVoucherDetails', JSON.stringify(details));
        this.voucherDetails.next(details);
      }
    }
  }

  tabview(displaycomponent) {
    this.tabchangedtls.next(displaycomponent);
  }

  setSellStatus(sellResponse) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (sellResponse != null) {
        localStorage.setItem('sellStatus', JSON.stringify(sellResponse));
        this.sellStatus.next(sellResponse);
      }
    }
  }

  setSegmentsCount(segmentCount) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (segmentCount != null) {
        localStorage.setItem('segmentCount', JSON.stringify(segmentCount));
        this.segmentCount.next(segmentCount);
      }
    }
  }
  forgotcomponent(displaycomponent) {
    this.forgotchangedtls.next(displaycomponent);
  }

  setEuropCarPlansDetails(planDetails) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (planDetails != null) {
        localStorage.setItem('EuroCarPlans', JSON.stringify(planDetails));
        this.euroCarPlans.next(planDetails);
      }
    }
  }

  setAirportObj(airport) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (airport != null) {
        localStorage.setItem('airportobj', JSON.stringify(airport));
        this.airports.next(airport);
      }
    }
  }

  setHotelCancelPolicyDtls(Obj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (Obj != null) {
        localStorage.setItem('hotelCancelItems', JSON.stringify(Obj));
        this.hotelCancelDtls.next(Obj);
      }
    }
  }

  setBillingAddress(addressObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (addressObj != null) {
        localStorage.setItem('billingAddress', JSON.stringify(addressObj));
        this.billingDetails.next(addressObj);
      }
    }
  }

  openInGoogleMaps(lat, lang) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      let url = 'https://maps.google.com/?q=' + lat + ',' + lang;
      window.open(url, '_blank');
    }
  }

  setTempRefId(val) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.setItem('tempRefId', val);
      this.tempReferenceID.next(val);
    }
  }

  setTempCurrencyValue() {
    this.tempcurencySet.next(true);
  }

  setCurrencyInPages() {
    this.setCurrencyInPages$.next(true);
  }

  closeMenuFromOtherService() {
    this.closeMenuFromOtherService$.next(true);
  }

  setMinMax(price) {
    console.log("Inside of set Min Max ", price);
    if (price) {
      this.minmax.next({ min: price.min, max: price.max });
      if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
        localStorage.setItem('minMaxValues', JSON.stringify({ min: price.min, max: price.max }));
      }
    }
  }

  getMinMax() {
    return this.minmax;
  }

  setInfantDetails(infObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (infObj != null) {
        localStorage.setItem('infObj', JSON.stringify(infObj));
        this.infantDetails.next(infObj);
      }
    }
  }


  setPaymentSearchParams(infObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (infObj != null) {
        localStorage.setItem('PaymentSearchParams', JSON.stringify(infObj));
        this.PaymentSearchParams$.next(infObj);
      }
    }
  }



  setPaymentCurrency(currency) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (currency != null) {
        localStorage.setItem('paymentCurrency', currency);
        this.paymentCurrency.next(currency);
      }
    }
  }

  setCity(city: string) {
    this.city.next(city);
  }

  getCity() {
    return this.city;
  }

  setFlightSelectedFlag(flag: string) {
    if (isPlatformBrowser) {
      localStorage.setItem('isFlightSelected', flag);
    }
  }
  removeFlightSelectedFlag() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      this.removeSelectedFlight$.next(true);
      if (
        localStorage.getItem('isFlightSelected') != null &&
        localStorage.getItem('isFlightSelected') != undefined
      ) {
        localStorage.removeItem('isFlightSelected');
      }
    }
  }

  setPaypalFailureDetails(obj: any) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (obj != null) {
        localStorage.setItem('paypalFailureDetails', JSON.stringify(obj));
        // this.paypalFailureDetails.next(obj);
      }
    }
  }

  setAgeBands(bandobj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (bandobj != null) {
        localStorage.setItem('agebands', JSON.stringify(bandobj));
        this.agebanddetails.next(bandobj);
      }
    }
  }

  setTravellerObj(travellerObj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (travellerObj != null) {
        localStorage.setItem('travellerObj', JSON.stringify(travellerObj));
        this.travellerDtls.next(travellerObj);
      }
    }
  }

  removeActivityDtls() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('travellerObj');
    }
  }

  setFlightExtras(extras) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (extras != null) {
        localStorage.setItem('extras', JSON.stringify(extras));
        this.flightExtras.next(extras);
      }
    }
  }

  setFromAndToAmounts(from, to) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (from != null) {
        let amts = { fromAmount: from, toAmount: to };
        localStorage.setItem('amounts', JSON.stringify(amts));
        this.amounts.next(amts);
      }
    }
  }

  setPaymentCards(cards) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (cards != null) {
        localStorage.setItem('paymentCards', JSON.stringify(cards));
        this.paymentCards.next(cards);
      }
    }
  }

  setAssignedSeats(seats) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (seats != null) {
        localStorage.setItem('assignedseats', JSON.stringify(seats));
        this.assignedSeats.next(seats);
      }
    }
  }

  setAirlines(airlines) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (airlines != null) {
        localStorage.setItem('airlines', JSON.stringify(airlines));
        this.airlinesList.next(airlines);
      }
    }
  }

  setAirports(airports) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (airports != null) {
        localStorage.setItem('airports', JSON.stringify(airports));
        this.airportsList.next(airports);
      }
    }
  }

  setHotelDtlsReq(request) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (request != null) {
        localStorage.setItem('htldtls_req', request);
        this.hotelDtlsReq.next(request);
      }
    }
  }

  setHotelTravelRequest(request) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (request != null) {
        localStorage.setItem('htlbk_req', request);
        this.hotelBkReq.next(request);
      }
    }
  }

  setPostBookSuccess(obj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (obj != null) {
        localStorage.setItem('post_ancl_success', JSON.stringify(obj));
        this.postAnclConfirmationData.next(obj);
      }
    }
  }

  setSession(sessionobj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (sessionobj != null) {
        localStorage.setItem('sessionObj', JSON.stringify(sessionobj));
        this.postAnclConfirmationData.next(sessionobj);
      }
    }
  }

  setAncillarySelected(selected) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (selected != null) {
        localStorage.setItem('isAncillaryDone', selected);
        this.isAncillarySelected.next(selected);
      }
    }
  }

  setCouponObj(Obj) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (Obj != null) {
        localStorage.setItem('couponObj', JSON.stringify(Obj));
        this.couponObj.next(Obj);
      }
    }
  }
  removeCouponObj() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      localStorage.removeItem('couponObj');
    }
  }
  forceLogout() {
    this.logOutUserId.next(true);
  }

  sendIPUrl(url: string) {
    this.ipAddressUrl$.next(url);
  }

  setRequestId(requestId, page, requestList = []) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (requestId != null) {
        console.log(requestId, "  request ID  Length", requestList.length)
        if (requestList.length > 0) {
          console.log("insie of if length greater than 0 ")
          localStorage.setItem('requestIDList', JSON.stringify(requestList));
        } else {
          let requestIDList = localStorage.getItem('requestIDList');
          let requestObject: Array<{ page: string, requestId: string, fetched: boolean }> = [];
          if (requestIDList == null && requestIDList == undefined) {
            requestObject = [{ 'page': page, 'requestId': requestId, 'fetched': false }];
            localStorage.setItem('requestIDList', JSON.stringify(requestObject));
          } else {
            requestObject = JSON.parse(requestIDList);
            if (!(requestObject.findIndex(x => x.page == page) > -1)) {
              requestObject.push({ 'page': page, 'requestId': requestId, 'fetched': false });
            }
          }
          localStorage.setItem('requestIDList', JSON.stringify(requestObject));
          this.requestIDList$.next(requestObject);
        }

      }
    }
  }











  setRequestIdInSession(requestId, page, requestList = []) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (requestId != null) {
        console.log(requestId, "  request ID  Length", requestList.length)
        if (requestList.length > 0) {
          console.log("insie of if length greater than 0 ")
          localStorage.setItem('requestIDList', JSON.stringify(requestList));
        } else {
          let requestIDList = localStorage.getItem('requestIDList');
          let requestObject: Array<{ page: string, requestId: string, fetched: boolean }> = [];
          if (requestIDList == null && requestIDList == undefined) {
            requestObject = [{ 'page': page, 'requestId': requestId, 'fetched': false }];
            localStorage.setItem('requestIDList', JSON.stringify(requestObject));
          } else {
            requestObject = JSON.parse(requestIDList);
            if (!(requestObject.findIndex(x => x.page == page) > -1)) {
              requestObject.push({ 'page': page, 'requestId': requestId, 'fetched': false });
            }
          }
          localStorage.setItem('requestIDList', JSON.stringify(requestObject));
          this.requestIDListSession$.next(requestObject);
        }

      }
    }
  }


















  setToken(token: any) {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      if (token) {
        localStorage.setItem('token', token['token']);
        this.token$.next(token['token']);
      }
    }
  }

  closeRefereFrom() {
    this.closeReferenceFromOtherFiles.next(true);
  }


}
